export default __webpack_public_path__ + "static/media/_commonwealth.e650d81a.ico";